import React, { useState, useEffect, useCallback } from "react";
import { Table, Spin } from "antd";
import ListPagination, {
  LIST_DEFAULT_PAGE_SIZE,
  buildPageQuery,
  createPageChangeHandler,
  parseListFromPayload,
  parseTotalFromPayload,
} from "../../components/ListPagination";
import API, { COMBINED_RANKINGS } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";

const TEXT = {
  rank: "Thứ hạng",
  accountName: "Tên tài khoản",
  pointsReceived: "Số trận đoán trúng",
  isFakeCol: "Là người chơi fake",
  fakeLabel: "Tài khoản fake",
};

function mapRankingRow(item, index, pageZero, pageSize) {
  const rank =
    item?.rank != null
      ? Number(item.rank)
      : item?.position != null
        ? Number(item.position)
        : pageZero * pageSize + index + 1;
  const isFake = Number(item?.isFake) === 1;
  return {
    key: String(item?.id ?? item?.userId ?? item?.key ?? `rk-${index}`),
    rank,
    username: item?.username ?? item?.userName ?? "",
    points:
      item?.correctPredictions != null
        ? Number(item.correctPredictions)
        : item?.points != null
          ? Number(item.points)
          : item?.score != null
            ? Number(item.score)
            : item?.receivedPoints != null
              ? Number(item.receivedPoints)
              : 0,
    isFake,
  };
}

const Leaderboard = () => {
  const [loading, setLoading] = useState(false);
  const [rankingRows, setRankingRows] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(LIST_DEFAULT_PAGE_SIZE);
  const [totalRecords, setTotalRecords] = useState(0);

  const onPageChange = createPageChangeHandler(page, pageSize, setPage, setPageSize);

  const locale = { emptyText: TEXT_DEF.text0035 };

  const loadRanking = useCallback(async () => {
    setLoading(true);
    try {
      const { page: p, pageSize: size, query } = buildPageQuery(page, pageSize);
      const res = await API.get(`${COMBINED_RANKINGS}?${query}`);
      const payload = res.data?.data ?? res.data;
      const list = parseListFromPayload(payload);
      setRankingRows(
        list.map((item, i) => mapRankingRow(item, i, p - 1, size))
      );
      setTotalRecords(parseTotalFromPayload(payload, list.length));
    } catch (e) {
      console.warn(e);
      setRankingRows([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  }, [page, pageSize]);

  useEffect(() => {
    loadRanking();
  }, [loadRanking]);

  const rankingColumns = [
    {
      title: TEXT.rank,
      dataIndex: "rank",
      key: "rank",
      align: "center",
      width: 110,
    },
    {
      title: TEXT.accountName,
      dataIndex: "username",
      key: "username",
      align: "center",
    },
    {
      title: TEXT.pointsReceived,
      dataIndex: "points",
      key: "points",
      align: "center",
      width: 140,
    },
    {
      title: TEXT.isFakeCol,
      key: "isFake",
      align: "center",
      width: 180,
      render: (_, record) =>
        record.isFake ? (
          <span style={{ fontWeight: 500 }}>{TEXT.fakeLabel}</span>
        ) : (
          <span style={{ color: "rgba(0,0,0,0.25)" }}>—</span>
        ),
    },
  ];

  return (
    <div className="col-12" style={{ padding: "8px 0" }}>
      <Spin spinning={loading}>
        <Table
          rowKey="key"
          columns={rankingColumns}
          dataSource={rankingRows}
          pagination={false}
          bordered
          locale={locale}
          style={{ width: "100%" }}
        />
        <ListPagination
          current={page}
          total={totalRecords}
          pageSize={pageSize}
          onChange={onPageChange}
          unit="bản ghi"
        />
      </Spin>
    </div>
  );
};

export default Leaderboard;
